// extracted by mini-css-extract-plugin
export var emptyState = "_6v-d";
export var statCard = "_6v-c";
export var table = "_6v-0";
export var tableCell = "_6v-4";
export var tableCellClickable = "_6v-5 _6v-4";
export var tableCellDefault = "_6v-6 _6v-4";
export var tableCellEmpty = "_6v-8";
export var tableCellWithValue = "_6v-7";
export var tableContainer = "_6v-e";
export var tableHeaderWeight = "_6v-1";
export var tableHeaderZone = "_6v-2";
export var tableRowHeader = "_6v-3";
export var viewModeButton = "_6v-9";
export var viewModeButtonActive = "_6v-a _6v-9";
export var viewModeButtonInactive = "_6v-b _6v-9";